import DeliveryDateSelector, {
  type DeliveryDateSelectorProps,
} from './delivery-date-selector';

const DeliveryDateSelectorButton = (props: DeliveryDateSelectorProps) => {
  return (
    <div className="p-0 h-fit border rounded-md">
      <DeliveryDateSelector {...props} />
    </div>
  );
};

export default DeliveryDateSelectorButton;
